export { default as SurfaceConstants } from 'owa-calendar-surface-core-styles/lib/SurfaceConstants';

export { default as CalendarDayList } from './components/CalendarDayList';
export { default as CalendarSurface } from './components/CalendarSurface';
export type { CalendarSurfaceHandle } from './components/CalendarSurface';
export { default as MonthItemsPanel } from './components/MonthItemsPanel';
export { default as InDayScrollContainer } from './components/InDayScrollContainer';
export { default as CalendarExpandableAllDayWell } from './components/CalendarExpandableAllDayWell';

/**
 * CalendarDefaultSurfaceComponent has the minimum definition for a component to attach handlers and behaviors.
 * For all components that only bind external behaviors to a default div, we can export CalendarSurfaceDefaultComponent
 * under multiple names. If we do this, and later need to add default functionality to the component, we can build a
 * new component in owa-calendar-surface-core, export it with the same name, and we don't need to update any consumers
 */
export {
    default as CalendarSurfaceDefaultComponent,
    default as CalendarAllDayHeader,
    default as InDayContentContainer,
} from './components/CalendarDefaultSurfaceComponent';

export { default as combineHandlers } from './utils/combineHandlers';
export { default as toPixelString } from './utils/toPixelString';
export {
    usePixelsPerMinuteRatio,
    PixelsPerMinuteRatioProvider,
} from './utils/usePixelsPerMinuteRatio';
export * from './utils/constants';

export type {
    CalendarDayConfig,
    TypedCalendarDayConfig,
    CalendarDayContentConfig,
    TypedCalendarDayContentConfig,
} from './interfaces/CalendarDayConfig';
export type { default as VisibleTime } from './interfaces/VisibleTime';
export type { default as SurfaceUserOptions } from './interfaces/SurfaceUserOptions';
export type { default as SurfaceStore } from './interfaces/SurfaceStore';
export type { default as FocusableSurface } from './interfaces/FocusableSurface';
export type { default as CalendarSurfaceConfig } from './interfaces/CalendarSurfaceConfig';
export type { default as CalendarMonthContent } from './interfaces/CalendarMonthContent';
export type { default as CalendarMonthConfig } from './interfaces/CalendarMonthConfig';
export type { default as CalendarDayContent } from './interfaces/CalendarDayContent';
export type { DefaultSurfaceComponentWithProps } from './interfaces/DefaultSurfaceComponent';
